import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../app_components/Icon';

const SideNavMenuCard = ({ variant, icon, iconColor, title, subtitle, imageSrc, illustration, onClick }) => (
  <div
    className={`sideNav-card sideNav-card--${variant}`}
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    }}
  >
    <div className="sideNav-card__wave" aria-hidden="true" />
    <div className="sideNav-card__content">
      <div className="sideNav-card__iconCircle">
        <Icon name={icon} size={22} color={iconColor} />
      </div>
      <div className="sideNav-card__text">
        <span className="sideNav-card__title">{title}</span>
        <span className="sideNav-card__subtitle">{subtitle}</span>
      </div>
    </div>
    <div className="sideNav-card__illustration" aria-hidden="true">
      {imageSrc ? (
        <img src={imageSrc} alt="" className="sideNav-card__image" />
      ) : (
        illustration
      )}
    </div>
  </div>
);

SideNavMenuCard.propTypes = {
  variant: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  iconColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  illustration: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};

export default SideNavMenuCard;
